import { Timestamp } from "firebase/firestore";

export const PublicListingCollection = "public-listings";

export type RevealLevel = "trendline" | "trendline-with-amounts" | "hidden";
export type CountryRevealLevel = "top3" | "top10" | "hidden";
export type PublicListingStatus = "public" | "in-preview" | "not-active";

export type AppEntryType =
  | "chrome-extension"
  | "firefox-addon"
  | "ios-app"
  | "android-app"
  | "web-app";

export interface AppEntry {
  name: string;
  url: string;
  type: AppEntryType;
}

const APP_TYPE_PATTERNS: [RegExp, AppEntryType][] = [
  [/chromewebstore\.google\.com/, "chrome-extension"],
  [/chrome\.google\.com\/webstore/, "chrome-extension"],
  [/addons\.mozilla\.org/, "firefox-addon"],
  [/apps\.apple\.com/, "ios-app"],
  [/itunes\.apple\.com/, "ios-app"],
  [/play\.google\.com/, "android-app"],
];

export function inferAppType(url: string): AppEntryType {
  for (const [pattern, type] of APP_TYPE_PATTERNS) {
    if (pattern.test(url)) return type;
  }
  return "web-app";
}

export interface PublicListing {
  id: string;
  projectId: string;
  handle: string;
  status: PublicListingStatus;
  // Display options
  revenueDisplay: RevealLevel;
  subscriptionsDisplay: RevealLevel;
  countryDisplay: CountryRevealLevel;
  // Business info
  companyName?: string;
  websiteUrl: string;
  contactEmail?: string;
  logoUrl: string;
  // Apps / SKUs
  appEntries?: AppEntry[];
  // Timestamps
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export function mapDocToPublicListing(
  id: string,
  data: Record<string, unknown>,
): PublicListing {
  return {
    id,
    projectId: data.projectId as string,
    handle: data.handle as string,
    status: data.status as PublicListingStatus,
    revenueDisplay: data.revenueDisplay as RevealLevel,
    subscriptionsDisplay: data.subscriptionsDisplay as RevealLevel,
    countryDisplay: data.countryDisplay as CountryRevealLevel,
    companyName: data.companyName as string | undefined,
    websiteUrl: data.websiteUrl as string,
    contactEmail: data.contactEmail as string | undefined,
    logoUrl: data.logoUrl as string,
    appEntries: (data.appEntries as AppEntry[] | undefined) ?? undefined,
    createdAt: data.createdAt as Timestamp,
    updatedAt: data.updatedAt as Timestamp,
  };
}
